import { render, staticRenderFns } from "./LineChart.global.vue?vue&type=template&id=513e716a&lang=pug&"
import script from "./LineChart.global.vue?vue&type=script&lang=ts&"
export * from "./LineChart.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports